import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { NgClass } from '@angular/common';
import { MerchantStoreItem } from '../types/merchant-store-item.type';

@Component({
  selector: 'store-card',
  standalone: true,
  imports: [MatCardModule, NgClass],
  templateUrl: './store-card.component.html',
  styleUrl: './store-card.component.scss',
})
export class StoreCardComponent {
  @Input({ required: true }) store!: MerchantStoreItem;
  @Input({ required: true }) cardOnViewing?: MerchantStoreItem | null;

  @Output() emitStoreData = new EventEmitter<MerchantStoreItem>();

  getAddress() {
    if (this.cardOnViewing) {
      if (typeof (this.cardOnViewing.Address) === 'string') {
        return this.cardOnViewing.Address;
      } else {
        return (this.cardOnViewing.Address as any).description;
      }
    }
  }
}
